import React, { useEffect, useState } from "react";
import { Briefcase, Users, GraduationCap, Rocket } from "lucide-react";
import api from "../api";

function Card({ children, className = "" }) {
  return <div className={`rounded-2xl border border-slate-200 bg-white p-5 shadow-sm ${className}`}>{children}</div>;
}

export default function ClientDashboard() {
  const [me, setMe] = useState(null);
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get("/client/me").then((r) => setMe(r.data)).catch(() => {});
    api.get("/client/dashboard").then((r) => setData(r.data)).catch(() => {});
  }, []);

  const stats = data ? [
    { label: "Programs", value: data.programs_total, Icon: Briefcase },
    { label: "Published", value: data.programs_published, Icon: Briefcase },
    { label: "Contractors", value: data.contractors_total, Icon: Users },
    { label: "Registered for training", value: data.registered_for_training, Icon: GraduationCap },
    { label: "Training scheduled", value: data.training_scheduled, Icon: GraduationCap },
    { label: "Training completed", value: data.training_completed, Icon: GraduationCap },
    { label: "Ready for production", value: data.ready_for_production, Icon: Rocket },
    { label: "Active contractors", value: data.active_contractors, Icon: Users },
  ] : [];

  return (
    <div className="space-y-6" data-testid="client-dashboard">
      <div>
        <h2 className="text-lg font-bold text-slate-900">{me?.company?.name || "Client"} Portal</h2>
        <p className="text-sm text-slate-500">Your programs, your contractors, your training status. You only ever see your own company's data.</p>
      </div>
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {stats.map((s) => (
          <Card key={s.label}>
            <div className="flex items-start justify-between">
              <span className="text-xs font-semibold uppercase tracking-wide text-slate-400">{s.label}</span>
              <s.Icon className="h-4 w-4 text-violet-500" />
            </div>
            <div className="mt-3 text-2xl font-bold text-slate-900">{s.value}</div>
          </Card>
        ))}
      </div>
      {data && !data.production_data_available && (
        <Card><div className="text-sm text-amber-600" data-testid="client-no-production">No production data available yet — call/production metrics will appear here once connected.</div></Card>
      )}
    </div>
  );
}
